import { availableAvatarsType } from '../enums';

export const randomGenerateNumber = (min = 0, max = availableAvatarsType.length) =>
  Math.floor(Math.random() * (max - min)) + min;

export const createGuid = () => {
  const unique = (l) => Math.random().toString(16).slice(2, l);

  return `${unique(10)}-${unique(6)}-${unique(6)}-${unique(6)}-${unique(14)}`;
};
